export default {
	computed: {
		_labelDepartamento() {
			var obj = {
				departamento: this._traducao('global', 'departamento'),
				cadastroDeDepartamento: this._traducao(
					'global',
					'cadastroDeDepartamento'
				)
			}

			// MG-SIGA (PMMPG)
			if ($cliente.get('id') == '9') {
				obj.departamento = this._traducao('global', 'secao')
				obj.cadastroDeDepartamento = this._traducao('global', 'cadastroDeSecao')
			}

			return obj
		},

		_labelSolicitacao() {
			var obj = {
				titulo: this._traducao('menuSolicitaApoio', 'solicitaApoio'),
				subTitulo: this._traducao('menuSolicitaApoio', 'apoioAereo')
			}

			// UNIMED
			if ($cliente.get('id') == '7') {
				obj.subTitulo = 'REMOÇÃO MÉDICA'
			}

			// CASA MILITAR DA BAHIA
			if ($cliente.get('id') == '8') {
				obj.subTitulo = 'DE AERONAVES'
			}

			// MG-SIGA (PMMPG)
			if ($cliente.get('id') == '9') {
				obj.subTitulo = this._traducao('global', 'usoDeAereonave')
				obj.titulo = this._traducao('menuRGsolicitacoes', 'menuRGsolicitacao')
			}

			return obj
		},

		_labelOrdemMissao() {
			var obj = {
				titulo: this._traducao('menuOrdemMissao', 'menuOrdem'),
				subTitulo: this._traducao('menuOrdemMissao', 'menuMissao')
			}

			// UNIMED
			if ($cliente.get('id') == '7') {
				obj.titulo = 'DESPACHO'
				obj.subTitulo = 'REMOÇÃO MÉDICA'
			}

			// CASA MILITAR DA BAHIA
			if ($cliente.get('id') == '8') {
				obj.titulo = 'PLANEJAMENTO'
				obj.subTitulo = 'DE MISSÃO'
			}

			// HENRIMAR
			if ($cliente.get('id') == '12') {
				obj.titulo = 'PLANEJAMENTO'
				obj.subTitulo = 'DE VOO'
			}

			if (this._versaoSistema == 'S') {
				obj.subTitulo = 'BARCOS'
			}

			return obj
		},

		_labelMonitoramento() {
			var obj = {
				titulo: this._traducao('menuMonitoramento', 'menuMonitora'),
				subTitulo: this._traducao('menuMonitoramento', 'menuTempoReal')
			}

			// MG SIGA
			if ($cliente.get('id') == '9') {
				obj.titulo = this._traducao('global', 'monitoramento1')
				obj.subTitulo = this._traducao('submenu', 'aeronaves')
			}

			return obj
		},

		_labelDespacho() {
			var obj = {
				titulo: this._traducao('global', 'despacho'),
				subTitulo: this._traducao('global', 'despacho')
			}

			if ($cliente.get('id') == '21') {
				obj.titulo = 'ACIONAMENTO'
			}

			return obj
		},

		_labelRelatorioPrevencao() {
			var obj = {
				titulo: this._traducao('menuAGprevencao', 'menuAGrelatorio')
				// subTitulo: 'AERONAVES',
			}

			if ($cliente.get('id') == '9') {
				obj.titulo = this._traducao('menuAGprevencao', 'menuAGrelato')
			}

			return obj
		},

		_labelRastreamento() {
			var obj = {
				titulo: this._traducao('menuRastreamento', 'menuRastrea').toUpperCase(),
				subTitulo: this._traducao(
					'menuRastreamento',
					'menuRastreaAeronave'
				).toUpperCase()
			}

			// UNIMED
			if ($cliente.get('id') == '7') {
				obj.subTitulo = 'REMOÇÃO MÉDICA'
			}

			// CASA MILITAR DA BAHIA
			if ($cliente.get('id') == '8') {
				obj.subTitulo = 'AERONAVES E VEÍCULOS'
			}

			if (this._versaoSistema == 'S') {
				obj.subTitulo = 'BARCOS'
			}

			// MG SIGA
			if ($cliente.get('id') == '9') {
				obj.titulo = this._traducao('global', 'historico').toUpperCase()
				obj.subTitulo = this._traducao('global', 'voo').toUpperCase()
			}

			// BOA SC
			if ($cliente.get('id') == '38') {
				obj.titulo = this._traducao('global', 'historicoVoo').toUpperCase()
				obj.subTitulo = this._traducao('global', 'voo').toUpperCase()
			}

			return obj
		},

		_labelGestaoDeEnsino() {
			var obj = {
				titulo: this._traducao('submenu', 'gestaoDoEnsino'),
				subTitulo: this._traducao('submenu', 'teoricoEPratico')
			}

			return obj
		},

		// FALTA IMPLEMENTAR (OUTROS MODULOS TAMBÉM)
		_labelFDM() {},

		_labelRelatorios() {},

		_labelADMGeral() {},

		_labelQuadrantes() {
			var obj = {
				subTitulo: this._traducao('global', 'quadrantes')
			}
			return obj
		}
	}
}